// PlayByPlay event types live in common/types/gameSim.ts so UI's
// processLiveGameEvents renderer can reference them without crossing
// into server/. This file keeps the abstract logger class only.

import type { PlayByPlayEventOutput as BasketballEvent } from "../GameSim.basketball/PlayByPlayLogger.ts";
import type { TeamNum } from "../../../../common/types.ts";
import type { PlayByPlayEvent } from "../../../../common/types/gameSim.ts";

export type { PlayByPlayEvent };

type SportEvent = BasketballEvent;

export abstract class PlayByPlayLoggerBase<T extends SportEvent> {
	active: boolean = false;
	playByPlay: PlayByPlayEvent<T>[] = [];
	constructor(active: boolean) {
		this.active = active;
	}
	abstract logEvent(event: unknown): void;

	logStat(t: TeamNum, pid: number | undefined | null, s: string, amt: number) {
		if (!this.active) {
			return;
		}

		this.playByPlay.push({
			type: "stat",
			t,
			pid,
			s,
			amt,
		});
	}

	getPlayByPlay(boxScore: any): PlayByPlayEvent<T>[] | undefined {
		if (!this.active) {
			return;
		}

		return [
			{
				type: "init",
				boxScore,
			},
			...this.playByPlay,
		];
	}
}
